import React, { useContext, useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid'
import { Divider, Link, Typography, Button } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import Spacer from '../../../app/common/ui/Spacer';
import { navigate } from '@reach/router';

const MemberDirectoryPage = () => {
    const db = useContext(FireDataContext);
    const [members, setMembers] = useState([]);
    const { currentUser: { roles = [] } } = useContext(AuthContext);

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: `intermediaries`,
            hook: data => {
                setMembers(data.filter(({hidden}) => !hidden));
            },
            context: 'MemberDirectoryPage'
        })

        return unsubscribe;
    }, [db]);

    if (!members?.length) return <></>;

    return (
        <MemberMiniMenu>
            <div>
                <Typography variant="h6" color="initial">Intermediary Members</Typography>
                <Spacer />
                {
                    members?.sort((a, b) => a.profile?.title.localeCompare(b.profile?.title)).map(m => {
                        return (
                            <div key={m.id}>
                                <Grid container  >
                                    <Link href={`/members/${m.id}`}>
                                        <Grid item>{m.profile?.title ?? <ErrorIcon color="secondary" />}</Grid>
                                    </Link>
                                </Grid>
                                <Grid container >
                                    <Grid item xs={12}>{m.profile?.email}</Grid>
                                    <Grid item xs={12}>{m.profile?.phoneNumber}</Grid>
                                    {
                                        roles.includes('admin') &&
                                        <Grid item>
                                            <Spacer />
                                            <Button variant="contained" color="default" onClick={() => navigate(`/casework/info/${m.id}`)}>
                                                VIEW MEMBER'S CASES
                                            </Button>
                                        </Grid>
                                    }
                                </Grid>
                                <Spacer />
                                <Divider />
                                <Spacer />
                            </div>
                        )
                    })
                }
            </div>
        </MemberMiniMenu>
    );
};

export default MemberDirectoryPage;